var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSearchTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0001 24C24.109 24 19.3334 28.7756 19.3334 34.6667C19.3334 40.5577 24.109 45.3333 30.0001 45.3333C32.4011 45.3333 34.6168 44.54 36.3994 43.2012L41.6676 47.4157C42.8176 48.3358 44.4957 48.1493 45.4157 46.9993C46.3358 45.8492 46.1493 44.1711 44.9993 43.2511L39.7328 39.0379C40.3329 37.7039 40.6667 36.2243 40.6667 34.6667C40.6667 28.7756 35.8911 24 30.0001 24ZM24.6667 34.6667C24.6667 31.7211 27.0546 29.3333 30.0001 29.3333C32.9456 29.3333 35.3334 31.7211 35.3334 34.6667C35.3334 37.6122 32.9456 40 30.0001 40C27.0546 40 24.6667 37.6122 24.6667 34.6667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 2.66666C11.0546 2.66666 8.66675 5.05447 8.66675 7.99999V56C8.66675 58.9456 11.0546 61.3333 14.0001 61.3333H51.3334C54.279 61.3333 56.6667 58.9455 56.6667 56V18.6667C56.6667 17.977 56.405 17.3485 55.9753 16.8751L43.9822 3.54942C43.4765 2.98751 42.756 2.66666 42.0001 2.66666H14.0001ZM38.0001 7.99999H14.0001V56H51.3334V21.3333H40.6667C39.194 21.3333 38.0001 20.1394 38.0001 18.6667V7.99999ZM48.0124 16H43.3334V10.8011L48.0124 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSearchTwo);
export default __webpack_public_path__ + "static/media/file-search-two.41ac5ec83fc60110f603801e8775b4e4.svg";
export { ForwardRef as ReactComponent };